export default __webpack_public_path__ + "static/media/Fraunces.c767db37.ttf";